export const SUBSCRIBE = 'BILLING/SUBSCRIBE';
export const START_SUBSCRIPTION = 'BILLING/START_SUBSCRIPTION';
export const FINALIZE_SUBSCRIPTION = 'BILLING/FINALIZE_SUBSCRIPTION';
export const FAIL_SUBSCRIPTION = 'BILLING/FAIL_SUBSCRIPTION';
export const FAIL_CUSTOMER = 'BILLING/FAIL_CUSTOMER';
export const COUNTRIES_LOADED = 'BILLING/COUNTRIES_LOADED';
export const SET_CUSTOMER = 'BILLING/SET_CUSTOMER';
export const SET_NAMESPACE = 'BILLING/SET_NAMESPACE';
